import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

// Action Types: Get Default Voice Prompt
export const GET_DEFAULT_VOICE_PROMPT_REQUEST = 'GET_DEFAULT_VOICE_PROMPT_REQUEST';
export const GET_DEFAULT_VOICE_PROMPT_SUCCESS = 'GET_DEFAULT_VOICE_PROMPT_SUCCESS';
export const GET_DEFAULT_VOICE_PROMPT_FAILURE = 'GET_DEFAULT_VOICE_PROMPT_FAILURE';

// GET: voiceAgent/getDefaultVoicePrompt
export const getDefaultVoicePrompt = () => async (dispatch) => {
  dispatch({ type: GET_DEFAULT_VOICE_PROMPT_REQUEST });
  try {
    const response = await api.get('voiceAgent/getDefaultVoicePrompt');
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_DEFAULT_VOICE_PROMPT_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch default voice prompt';
    dispatch({ type: GET_DEFAULT_VOICE_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch default voice prompt';
    dispatch({ type: GET_DEFAULT_VOICE_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

